import { apiUrl } from '../config/api';
import { getStoredUser } from './auth';
import { isAboveSupervisorRole } from './roles';
import { normalizeUserProfile } from './userProfile';

export async function fetchUserProfile(email) {
  if (!email) return null;
  try {
    const res = await fetch(apiUrl('/api/users/profile'), {
      headers: { 'X-User-Email': email },
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.profile) return null;
    return normalizeUserProfile(data.profile);
  } catch {
    return null;
  }
}

export async function saveUserProfile(email, profile) {
  if (!email) throw new Error('Not signed in');
  const normalized = normalizeUserProfile(profile);
  const role = getStoredUser()?.role;
  const body = {
    name: normalized.name.trim(),
    signature: normalized.signature.trim(),
  };
  if (isAboveSupervisorRole(role)) {
    body.certificate_notify_offset_days = normalized.certificate_notify_offset_days;
  }
  const res = await fetch(apiUrl('/api/users/profile'), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-User-Email': email,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const detail = data.detail;
    const message = typeof detail === 'string' ? detail : data.message;
    throw new Error(message || `Save failed (${res.status})`);
  }
  return normalizeUserProfile(data.profile || normalized);
}
